<template>
  <div class="thin-scroll" style="max-height: 100%; overflow: scroll;">
    <!-- <base-search icon-position="left" :value="search" @input="onSearch" /> -->
    <div v-if="!facetLoading || selectedFacets.length > 0" :class="{'filter-category--scrollable': scrollable}">
      <template v-for="(item, index) in facetsWithValues">
        <div :key="index" class="filter-category">
          <base-dropdown
            v-if="item.parent === null || selectedFacetsNameIncludes(item) "
            block
            :label="fineTuneFacetName(item.name) | capitalize | truncate(50)"
            :active=" isExpanded(index) "
            size="m"
            class="filter-category__title"
            @click="toggleExpand(index)"
          />
          <base-dropdown
            v-else
            block
            disabled
            :label="fineTuneFacetName(item.name) | capitalize | truncate(50)"
            :active=" isExpanded(index) "
            size="m"
            class="filter-category__title filter-category__disabled"
          />
          <base-transition-expand>
            <div v-if="isExpanded(index) && !(item.parent !== null && !selectedFacetsNameIncludes(item)) " class="subitem filter-category__options">
              <div v-if="item.facet_values.length > 8" class="base-search">
                <input
                  v-model="facetSearch[index]" placeholder="Search" type="text"
                  class="mini-search"
                >
                <base-icon
                  class="icon"
                  icon="search-base"
                />
              </div>
              <div v-if="item.facet_values.length > 8" class="spacer" />
              <template v-for="(subitem, subitemIndex) in item.facet_values">
                <base-checkbox
                  v-if="subitem.name && (subitem.name.toLowerCase().indexOf(facetSearch[index].trim().toLowerCase()) !=-1)"
                  :key="subitemIndex + '-' + index"
                  :value="selectedFacets.includes(subitem.id)"
                  block
                  black
                  :label="subitem.name | capitalize | truncate(50)"
                  @input="$emit('toggle-select', subitem)"
                />
              </template>
            </div>
          </base-transition-expand>
        </div>
      </template>
    </div>
    <div v-else class="skeleton__cont">
      <template v-for="i in 4">
        <div :key="'skeleton_cont' + i">
          <base-skeleton class="skeleton__header" none />
          <div
            style="marginLeft: 30px;"
          >
            <base-skeleton
              v-for="(n,index) in skeletonArr" :key="`skeleton_${n}`"
              :class="'skeleton__' + skeletonArr[index]" none
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus';

export default {
  name: 'CatalogFilter',
  props: {
    scrollable: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    selectedFacets: { // e.g. Vuex state:  catalog.selectedFacets
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: [], // Selected subcategories
      facetSearch: [],
      showFilter: false,
      skeletonArr: ['first', 'second', 'third', 'fourth', 'fifth'],
    };
  },
  computed: {
    facetsWithValues() {
      const facet = this.items.filter((item) => item.facet_values.length > 0);
      if (facet.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showFilter = true;
      }
      EventBus.$emit('showFilter', this.showFilter);
      return facet;
    },
    selectedFacetsName() {
      return this.$store.state.catalog.selectedFacetsName;
    },
    facetLoading() {
      return this.$store.getters['catalog/facetLoading'];
    },
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.facetSearch = this.facetsWithValues.map(() => '');
      },
    },
  },
  mounted() {
    this.facetSearch = this.facetsWithValues.map(() => '');
  },
  methods: {
    fineTuneFacetName(name) { // XXX MATCHESFASHION only!
      const PRODUCT_CATALOG_FACET_GROUP = 'Group';

      if (name === PRODUCT_CATALOG_FACET_GROUP) {
        return 'Category';
      } else {
        return name;
      }
    },
    isExpanded(index) {
      return this.expanded[index];
    },
    toggleExpand(index) {
      this.$set(this.expanded, index, !this.expanded[index]);
      // this.expanded.map((item, i) => {
      //   if (i !== index) {
      //     this.expanded[i] = false;
      //     return this.expanded[i];
      //   }
      //   return null;
      // });
    },
    onSearch($event) {
      this.$emit('search', $event);
    },
    selectedFacetsNameIncludes(item) {
      // eslint-disable-next-line no-restricted-syntax
      for (const selected of this.selectedFacetsName) {
        if (selected.facet_id === item.parent) return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-category{
  &__title{
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    color: $dark-black;
  }
  &--scrollable {
    overflow-y: auto;
    max-height: 100vh;
  }
  &__disabled{
    color: $gray-light-2;
    :hover{
      cursor: not-allowed;
    }
  }
}
.subitem{
  max-height: 234px;
  overflow-y: auto;
  // max-height: 280px;
}
::v-deep .base-checkbox__button {
  display: flex;
  & .base-checkbox__label {
    display: inline-block;
  }
}
::v-deep .base-search__input {
  &::placeholder {
    color: $gray-light-2;
  }
}
::v-deep .base-text--light{
  font-family: "SilkaMedium"
}
::v-deep .base-checkbox__button .base-checkbox__label {
  font-family: "SilkaLight";
  font-weight: 400 !important;
  font-size: 14px;
}

.mini-search{
  font-family: $font-family-sans-serif-light;
  font-size: 0.75rem;
  background-color: #FFF;
  color: $black;
  border: 1px solid #C6C6C6;
  padding: 8.5px 8px 8.5px 30px;
  border-radius: 5px;
  min-width: 100%;
  height:30px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: outline 0.2s;
  outline: solid 5px transparent;
  &:focus{
      // outline: solid 2px $header-bg-clients; // IDK why this color but it was designed like this.
      outline: solid 0px #0A0A0A;
      border: 1px solid #0A0A0A;
      border-radius: 5px;
    }
}
.icon{
    position: absolute;
    left: 10px;
    height: 15px;
    width:15px;
    top:8px;
}
.base-search{
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-left: auto;
  position: relative;
  height: toRem(35px);
  height: 36px;
  justify-content:center;
  position:absolute;
  width: 95%;
  background-color:#FFF;
  z-index: 100;

}
.spacer{
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-left: auto;
  position: relative;
  height: toRem(35px);
  height: 36px;
  justify-content:center;
  width: 95%;
  background-color:#FFF;
  z-index:99;

}

.skeleton{
  height: 12.25px;
  &__header{
    display:block;
    background-color: #e2e2e2;
    height: 12.25px;
    margin-top: 22.5px;
  }
  &__first{
    display:block;
    background-color: #e2e2e2;
    width: 110px;
    margin-top: 22.5px;

  }
  &__second{
    display:block;
    background-color: #e2e2e2;
    width: 153px;
    margin-top: 22.5px;

  }
  &__third{
    display:block;
    background-color: #e2e2e2;
    width: 127px;
    margin-top: 22.5px;

  }
  &__fourth{
    display:block;
    background-color: #e2e2e2;
    width: 114px;
    margin-top: 22.5px;

  }
  &__fifth{
    display:block;
    background-color: #e2e2e2;
    width: 163px;
    margin-top: 22.5px;

  }
  &__cont{
    position: absolute;
    overflow: hidden;
    max-height:100%;
    display:inline-block;
  }
}
</style>
